var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuestPromotion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.375 12.25H35.875V42H46.375C48.307 42 49.875 40.432 49.875 38.5V15.75C49.875 13.818 48.307 12.25 46.375 12.25ZM16.625 36.75H32.375V5.25H16.625V36.75ZM13.125 5.25H16.625V3.5C16.625 3.5 16.562 0 13.125 0H9.625C7.693 0 6.125 1.568 6.125 3.5V52.5C6.125 54.432 7.693 56 9.625 56H13.125C15.057 56 16.625 54.432 16.625 52.5V36.75H13.125V5.25Z",
    fill: "#B3D5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.125 5.25H16.625V3.5C16.625 3.5 16.562 0 13.125 0H9.625C7.693 0 6.125 1.568 6.125 3.5V52.5C6.125 54.432 7.693 56 9.625 56H13.125C15.057 56 16.625 54.432 16.625 52.5V36.75H13.125V5.25Z",
    fill: "#5D89EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuestPromotion);
export default __webpack_public_path__ + "static/media/guest-promotion.291d6949.svg";
export { ForwardRef as ReactComponent };